import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import OtpInput from 'react-otp-input';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import IconEmail from '../../assets/icon-email.svg';
import IconPhone from '../../assets/icon-phone.svg';
import IconReg from '../../assets/icon-registration.svg';
import IconPhoneVerify from '../../assets/phone-verification-icon.svg';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';
import { getRequest, postRequest } from '../../helpers/apiHandler';
import { onLogout, setLoginSuccess } from '../../store/actions/reduxAction';

const PhoneVerification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { access_token } = useSelector((state) => state.auth.user)
  const [hasSendOtp, setHasSendOtp] = useState(false);
  const TIMER = 30000;

  const params = useParams();
  const [otp, setOtp] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const check_if_logged_in = () => {

    const data = { headers: { Authorization: access_token.token } };
    getRequest('/user/me', data, (res) => {
      if (res.success) {
        const { active, phone_active, role } = res.data;

        dispatch(setLoginSuccess(res));
        if (role === 'admin') return navigate('/admin/dashboard');
        if (!active) return navigate(`/email/verify/${access_token.token}`);
        if (!phone_active) return navigate(`/phone/verify/${access_token?.token}`);
        if (phone_active && active) return navigate('/dashboard');
      }
    });
  }

  useEffect(() => {
    check_if_logged_in();
  }, []);

  const handleLogout = () => {
    dispatch(onLogout());
    localStorage.clear();
    navigate('/login');
  };


  const handleOtpActivation = () => {
    const data = {
      phone_number: phoneNumber,
      country_iso: 'MY',
      is_updating: false, // Set this to false because this is the first phone verification
    };
    postRequest(`/auth/request-otp`, data, access_token.token, res => {
      if (res.success) {
        setHasSendOtp(true);
        setAlertState({
          message: res.message,
          show: true,
          variant: 'success',
        });
      } else {
        setHasSendOtp(false);
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const handleVerifyOtp = () => {
    const data = {
      otp_code: otp,
      is_updating: false, // Set this to false because this is the first phone verification
    };
    postRequest(`/auth/validate-otp`, data, access_token.token, res => {
      if (res.success) {
        const { active, phone_active } = res.data;
        dispatch(setLoginSuccess(res));
        if (!active) return navigate(`/email/verify/${access_token.token}`);
        if (!phone_active) return navigate(`/phone/verify/${access_token?.token}`);
        if (phone_active && active) return navigate('/dashboard');
      } else {
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const handleOtpChange = value => {
    setOtp(value);
  };

  const handlePhoneNumberChange = value => {
    setPhoneNumber(value);
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  useEffect(() => {
    if (hasSendOtp) {
      setTimeout(() => {
        setHasSendOtp(false);
      }, TIMER);
    }
  }, [hasSendOtp]);

  return (
    <div className="Authenticate PhoneVerification">
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <div className="account-activation-wrapper">
        <div className="account-activation">
          <div className="account-activation-step">
            <div className="account-activation-step-item">
              <img src={IconReg} alt="..." />
              <div>Registration</div>
            </div>
            <div className="divider-line" />
            <div className="account-activation-step-item">
              <img src={IconEmail} alt="..." />
              <div>Email Verification</div>
            </div>
            <div className="divider-line" />
            <div className="account-activation-step-item active-item">
              <img src={IconPhone} alt="..." />
              <div>Mobile Verification</div>
            </div>
          </div>
          <img alt="..." src={IconPhoneVerify} height={185} />
          <h3>Your email is successfully verified!</h3>
          <p>
            You're almost there! Kindly enter your mobile number below to
            <br />
            receive your one-time password (OTP).
          </p>
          <div className="phone-number-wrapper">
            <PhoneInput
              international
              placeholder="Enter mobile number"
              defaultCountry="MY"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
            />
            <Button
              variant="primary"
              style={{ minWidth: 145 }}
              onClick={handleOtpActivation}
              disabled={hasSendOtp}
              className='btn-phone-verification'
            >
              Send
            </Button>
          </div>
          <div className="divider-line" style={{ width: '100%' }} />
          <h4>Enter your one time password</h4>
          <OtpInput
            value={otp}
            onChange={handleOtpChange}
            numInputs={4}
            renderInput={props => <input {...props} />}
            containerStyle="otp-wrapper"
            inputStyle="otp-input"
          />
          <div className="d-flex justify-content-center align-items-center w-100">
            <Button variant="primary" style={{ minWidth: 160 }} onClick={handleVerifyOtp}>
              Verify
            </Button>
          </div>

          <p>
            Need help? Reach out to our <a href="mailto:elfoa2psupport@elfo.com">Support Team</a>

            <button className="dropdown-item dropdown-item-logout" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt mr-2" />
              Logout
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};


export default PhoneVerification
